
import { formatDate } from "../../utils";
import { Prop, Component, Watch, Vue } from "vue-property-decorator";

@Component
export default class DateField extends Vue {
  localValue = "";
  $refs!: {
    input: HTMLInputElement;
  };

  @Prop({ default: "" })
  id: string;

  @Prop({ default: "name" })
  name: string;

  @Prop({ default: "" })
  value: string;

  @Prop({ default: "displayName" })
  placeholder: string;

  @Prop({ default: true })
  type: boolean;

  @Prop({ default: false })
  timeOnly: boolean;

  @Prop({ default: "MM/DD/YYYY" })
  format: string;

  @Prop({ default: "1111" })
  formatted: string;

  mounted() {
    this.localValue = this.value;
  }

  @Watch("value")
  valueChanged(val) {
    this.localValue = val;
  }

  get formattedValue() {
    return this.localValue ? formatDate(this.localValue, "YYYY-MM-DD") : "";
  }

  set formattedValue(val) {
    this.localValue = val;
  }

  toggleDatePicker(e) {
    let target = `${e}_ref`;
    this.$refs[target].$el.click();
  }

  updateDate(obj) {
    if (obj === null) {
      this.$emit("input", null);
    } else if (obj.end) {
      this.$emit("input", `${obj.start} ~ ${obj.end}`);
    } else {
      this.$emit("input", obj);
    }
  }

  reset() {
    this.localValue = "";
  }
}
